<ng-template #logoutModal>
    <div #here class="modal-body ">
        <h3 class="mt-5 modal-title text-primary text-center fw-bold">Cerrar sesión de Aldda</h3>
        <button type="button" class="btn-close pull-right" aria-label="Close" (click)="closeModal()" style="position: absolute;top: 1rem;right: 1rem;"></button>

        <div class="row mt-3">
          <div class="col-10 offset-1 mb-5 text-center">
            <p>Estás a punto de cerrar sesión en Aldda, si lo deseas, puedes cambiar de<br/>Sujeto Obligado sin tener que volver a iniciar sesión</p>
            <div class="d-flex justify-content-center gap-3 mt-4">
              <button class="btn btn-success py-2" (click)="redirectSelectSubjectObliged()">Cambiar Sujeto Obligado</button>
              <button class="btn btn-primary text-white py-2" (click)="signOut()">Cerrar Sesión</button>
            </div>
          </div>
        </div>
    </div>
</ng-template>
